module.exports = __webpack_public_path__ + "static/media/delete.05ec46ce.svg";